import './SaasRouteFallback.css';

/**
 * Lazy-route placeholder that keeps the surrounding shell painted.
 * Must sit *inside* Layout's outlet (or wrap a single out-of-shell route) —
 * never wrap `<Layout />` itself, or the sidebar/chrome remounts on every navigation.
 */
export function SaasRouteFallback({ fullBleed = false }: { fullBleed?: boolean }) {
  return (
    <div
      className={fullBleed ? 'saas-route-fallback saas-route-fallback--full' : 'saas-route-fallback'}
      aria-busy="true"
      aria-live="polite"
    />
  );
}
